import React from 'react';

const PrimaryButton = ({ content, type }) => {
  return (
    <button
      type={'button' ?? type}
      className="rounded-md bg-svisit-primary-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-xs hover:bg-svisit-primary-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-svisit-primary-600 m-2 hover:cursor-pointer"
    >
      {content}
    </button>
  );
};

export default PrimaryButton;
